import { ProductCard } from '@components/display/cards';
import { RegistrationEventListItem } from '@event/types';
import VerticalAlignBottomIcon from '@mui/icons-material/VerticalAlignBottom';
import { FormattedMessage } from 'react-intl';

export const EventProductCard = ({
    event,
    onDownloadCertificate,
    isCertificatesDownloading,
}: {
    event: RegistrationEventListItem;
    onDownloadCertificate: () => void;
    isCertificatesDownloading: boolean;
}) => (
    <ProductCard
        key={event.id}
        image={{
            url: event.banner_image,
            alt_text: event.name,
        }}
        slug={`/${event.type}/${event.id}`}
        title={event.name}
        date={{
            start: event.date_start ?? '',
            end: event.date_end ?? '',
        }}
        link={{
            text: <FormattedMessage id="account.events.downloadCertificate" defaultMessage="Download Certificate" />,
            icon: <VerticalAlignBottomIcon />,
            fn: onDownloadCertificate,
            loading: isCertificatesDownloading,
        }}
        style={{
            flex: '0 0 calc(25% - 8px)',
        }}
        disabled={isCertificatesDownloading}
    />
);
